export const datePersonal = (val) => {
  var arr = val.split('-')
  return arr[arr.length - 1]
}



// WEBPACK FOOTER //
// ./src/filters/datePersonal.js